import React from 'react';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import { useTranslation } from 'react-i18next';

const QuantityInputBoxes = ({
    item,
    index,
    lotItem,
    lotItemIdx,
    lotSerialValueEntered,
    showTopLabel,
    isChildItem,
    isFromReportScreen,
}) => {
    const { t } = useTranslation();
    return (
        <>
            <TextWithInputs
                name={t('reportUsage.itemList.used')}
                placeholder={t('reportUsage.itemList.qty')}
                onkeyUp={(e) =>
                    lotSerialValueEntered(e, item, index, lotItem, lotItemIdx)
                }
                value={
                    lotItem.Used || (lotItem.used === false ? '' : lotItem.used)
                }
                maxLength={2}
                inputHeight={'40px'}
                inputWidth={'48px'}
                alignText={'center'}
                topLabel={
                    showTopLabel &&
                    t('reportUsage.record.itemsList.QuantityInputBoxes.used')
                }
                inputBorder={
                    lotItem.isInvalidQtyMsg?.length > 0 && '2px solid #FACFD6'
                }
                //paddingLeft={'18px'}
            />

            {!item.isBundleItem &&
                !isChildItem &&
                isFromReportScreen === undefined && (
                    <TextWithInputs
                        name={t('reportUsage.itemList.other')}
                        placeholder={t('reportUsage.itemList.qty')}
                        onkeyUp={(e) =>
                            lotSerialValueEntered(
                                e,
                                item,
                                index,
                                lotItem,
                                lotItemIdx
                            )
                        }
                        value={lotItem.Other || lotItem.other}
                        maxLength={2}
                        inputHeight={'40px'}
                        inputWidth={'48px'}
                        alignText={'center'}
                        topLabel={
                            showTopLabel && t('reportUsage.itemList.other')
                        }
                        //paddingLeft={'8px'}
                    />
                )}
        </>
    );
};

export default QuantityInputBoxes;
